import React, { Suspense, lazy } from 'react';
import { useDispatch } from 'react-redux';
import { link_click } from '../redux/actions';
import menuitems from '../menuitems';

// The "Account" crumb shown on Account-group pages (Messages, Downloads). Clicking it
// navigates to the Profile page, mirroring ProfileMenu's openPage(Profile, ...). The
// Account group is resolved lazily inside the handler (not at module load) so the
// menuitems <-> page-component import cycle can't leave it undefined.
const Profile = lazy(() => import('../Contents/User/UserAdmin/Profile'));

function AccountBreadcrumbLink() {
  const dispatch = useDispatch();

  const goToProfile = (e) => {
    e.preventDefault();
    const accountSection = menuitems.find((m) => m.text === 'Account');
    dispatch(
      link_click(
        <Suspense fallback={<div />}>
          <Profile />
        </Suspense>,
        'Profile',
        'fa-solid fa-user-astronaut',
        accountSection,
        0,
        'profile'
      )
    );
  };

  return (
    <a href='#' onClick={goToProfile}>
      Account
    </a>
  );
}

export default AccountBreadcrumbLink;
